<script setup>
import FenixLogo from "@/components/FenixLogo.vue";
import AnimatedSection from "@/components/AnimatedSection.vue";
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-background cyber-grid relative overflow-hidden p-4">
    <!-- Ambient glow effects (Design System) -->
    <div class="absolute top-1/4 right-1/4 w-96 h-96 bg-accent/5 rounded-full blur-3xl pointer-events-none" />
    <div class="absolute bottom-1/4 left-1/4 w-64 h-64 bg-accent/3 rounded-full blur-2xl pointer-events-none" />
    
    <div class="w-full max-w-[420px] relative z-10">
      <!-- Logo Header -->
      <AnimatedSection animation="fade-down" class="mb-8 flex justify-center">
        <FenixLogo size="xl" />
      </AnimatedSection>
      
      <!-- Glass Container (Design System 3.2) -->
      <AnimatedSection animation="scale" :delay="100">
        <div class="rounded-xl border border-border/50 bg-card/80 backdrop-blur-sm shadow-2xl overflow-hidden cyan-border-glow p-6 md:p-8">
          <slot />
        </div>
      </AnimatedSection>

      <!-- Footer Links Area -->
      <AnimatedSection animation="fade-up" :delay="200">
        <div class="mt-6 text-center">
          <slot name="footer" />
        </div>
      </AnimatedSection>
    </div>
  </div>
</template>
